import { gql } from '@src/lib/gql'

/** Expert rate preview for paid session booking. */
export const ADVISOR_SESSION_BOOK_EXPERT = gql`
  query AdvisorSessionBookExpert($userId: String!) {
    advisorProfile(userId: $userId) {
      id
      advisorProfileId
      hourlyRate
      isSessionEnabled
      canAcceptSessions
      timezone
      sessionWeeklyHours
      user {
        id
        userId
        fullName
        displayName
        pictureUrl
      }
    }
  }
`
